import React from "react";
import { Loading } from "./Loading";
import { Error } from "./Error";
import { Empty } from "./Empty";
import { Box, SxProps } from "@mui/material";

export interface IStateProps {
  loading?: boolean;
  error?: boolean;
  empty?: boolean;
  loadingCopy?: string;
  errorCopy?: string;
  emptyCopy?: string;
  emptyComponent?: React.ReactNode;
  children?: React.ReactNode;
  sx?: SxProps;
}
export const State: React.FC<IStateProps> = ({
  loading,
  error,
  empty,
  loadingCopy,
  errorCopy,
  emptyCopy,
  emptyComponent,
  children,
  sx,
}) => {
  return !loading && !error && !empty ? (
    <>{children}</>
  ) : (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: 300,
        ...sx,
      }}
    >
      {loading ? (
        <Loading copy={loadingCopy} />
      ) : error ? (
        <Error copy={errorCopy} />
      ) : empty ? (
        emptyComponent || <Empty copy={emptyCopy} />
      ) : null}
    </Box>
  );
};
